<template>
  <div class="save-wrap new-saving" v-loading.fullscreen="payLoading">
    <div class="saving-wrap">
      <div class="saving-header">
        <span>{{ tokenType === 'diamond' ? '當前鑽石' : '儲值nicee幣' }}</span>
        <div
          v-if="userInfo && accountInfo"
          class="balance"
          @click="handleRoute('/saving')"
        >
          <img
            src="~@/assets/image/icons/diamond.png"
            v-if="isRechargeDiamond"
          />

          <img src="~@/assets/image/icons/gold-icon.png" v-else />
          <!-- prettier-ignore -->
          <span>{{ tokenType === 'diamond'? (accountInfo.diamondBalance || 0) : (accountInfo.balance || 0) }}</span>
        </div>
      </div>
      <div class="saving-content" :class="{ 'has-commission': hasCommission }">
        <slot></slot>
        <p class="line-title recharge-type-title">儲值方式</p>
        <div class="saving-type">
          <template v-if="isMergeCreditCard">
            <div class="saving-btn">
              <span
                class="number-item"
                :class="{
                  checked: checkPayType === payTypeEnum.CREDIT
                }"
                @click="selectCreditCardPayment()"
              >
                <div class="creditcard-Info">
                  信用卡<br />
                  <span class="credit-type" :title="creditCardInfo">{{
                    creditCardInfo
                  }}</span>
                </div>
              </span>
            </div>
          </template>
          <template v-if="!isMergeCreditCard">
            <div class="saving-btn">
              <!-- <div class="activity-info">限時鑽石贈送</div> -->
              <span
                class="number-item"
                :class="{
                  checked: checkPayType === payTypeEnum.CREDIT
                }"
                @click="selectPayType(payTypeEnum.CREDIT)"
              >
                <div class="creditcard-Info">
                  信用卡<br />
                  <span class="credit-type" :title="creditCardInfo">{{
                    creditCardInfo
                  }}</span>
                </div>
              </span>
            </div>
          </template>

          <div class="saving-btn">
            <span
              class="number-item"
              :class="{
                checked: checkPayType === payTypeEnum.ATM
              }"
              @click="selectPayType(payTypeEnum.ATM)"
              >ATM轉賬</span
            >
          </div>
          <div class="saving-btn">
            <span
              class="number-item"
              :class="{
                checked: checkPayType === payTypeEnum.CVS
              }"
              @click="selectPayType(payTypeEnum.CVS)"
              >超商代碼</span
            >
          </div>
          <div class="saving-btn">
            <div
              class="number-item"
              :class="{
                checked: checkPayType === payTypeEnum.PAYPAL
              }"
              @click="selectPayType(payTypeEnum.PAYPAL)"
            >
              <img class="we-chat" src="./images/paypal.png" />
            </div>
          </div>

          <div class="saving-btn">
            <div
              class="number-item"
              :class="{
                checked: checkPayType === payTypeEnum.ALIPAY
              }"
              @click="selectPayType(payTypeEnum.ALIPAY)"
            >
              <img class="we-chat" src="./images/alipay.png" />
            </div>
          </div>
          <!-- <div class="saving-btn">
            <div
              class="number-item"
              :class="{
                checked: checkPayType === payTypeEnum.WECHAT
              }"
              @click="selectPayType(payTypeEnum.WECHAT)"
            >
              <img class="we-chat" src="./images/weChatPay.png" />
            </div>
          </div> -->
        </div>
        <tappay-page
          ref="tappay"
          @submit="tappayRecharge"
          :visible="
            checkPayType === payTypeEnum.CREDIT &&
              paymentType === paymentTypeConfig.tapPay
          "
        ></tappay-page>
        <p class="line-title line-title-price">
          <span>儲值金額</span>
          <!-- <span class="tip-info" v-if="activitySwitch"
            >活動期間每個優惠儲值金額僅限享受一次滿贈優惠</span
          > -->
        </p>
        <div class="saving-number" v-loading="iapLoading">
          <div
            class="number-btn"
            v-for="(item, index) in numberArr.filter(v => !v.firstRechargeIap)"
            :key="index"
          >
            <div
              class="number-item"
              :class="{
                checked: item.iapItemId === checkedId
              }"
              @click="changeNumber(item)"
            >
              <p class="recharge-num">
                <img
                  src="~@/assets/image/icons/diamond.png"
                  v-if="isRechargeDiamond"
                />

                <img src="~@/assets/image/icons/gold-icon.png" v-else />
                <span v-if="isRechargeDiamond">{{
                  item.receivedAmount * 15
                }}</span>
                <span v-else>{{ item.receivedAmount }}幣</span>
                <!-- <span class="send-gold">送12</span> -->
                <span
                  class="send-gold"
                  v-if="
                    item.firstRechargeIap ||
                      (activitySwitch ? item.rechargeAward : item.residentAward)
                  "
                  >送{{
                    activitySwitch ? item.rechargeAward : item.residentAward
                  }}鑽</span
                >
              </p>
              <p class="pay-num">NT${{ item.paymentAmount }}</p>
              <!-- <span
                class="gift-num"
                v-if="
                  item.firstRechargeIap ||
                    (activitySwitch ? item.rechargeAward : item.residentAward)
                "
                >送{{
                  activitySwitch ? item.rechargeAward : item.residentAward
                }}幣</span
              > -->
            </div>
          </div>
        </div>
        <template v-if="showEmail">
          <p class="line-title">電子信箱</p>
          <div class="tip-wrap">
            填寫電子信箱用以收取支付通知信與電子發票。
          </div>
          <input
            v-model="email"
            class="email-input"
            placeholder="請填寫付款人電子郵箱"
          />
        </template>

        <!-- <p class="bank-tip">
          本公司採用喬睿科技 TapPay SSL 2048 bit
          交易系統，消費者刷卡時直接在銀行端系統中交易，本公司絕不留下您的信用卡資料，以保障您的權益。
          TapPay 交易系統通過 PCI-DSS
          國際信用卡組織安全稽核，周全保護您的信用卡資料安全。
        </p> -->

        <template v-if="!hasCommission">
          <div
            class="paypal-submit-button"
            :id="submitId"
            v-show="paymentType === paymentTypeConfig.payPal"
          ></div>

          <div
            class="confrim-save-btn"
            v-show="paymentType != paymentTypeConfig.payPal"
            @click="recharge"
          >
            確認儲值
          </div>
        </template>

        <p class="deadline" v-if="hasGift">
          活動時間：即日起至<span class="dead-time">{{ deadLineDate }}</span
          >截止
        </p>
      </div>
      <div class="commission-submit-box" v-if="hasCommission">
        <div
          class="paypal-box"
          :class="{ 'no-price': !checkedNumber }"
          v-show="paymentType === paymentTypeConfig.payPal"
        >
          <div class="paypal-submit-button" :id="submitId"></div>
        </div>

        <Submit
          :paymentAmount="checkedNumber"
          :taxation="iapItemSelected.taxAmount"
          :commission="iapItemSelected.chargesAmount"
          :giftAmmount="
            activitySwitch
              ? iapItemSelected.rechargeAward
              : iapItemSelected.residentAward
          "
          :isPaypal="paymentType === paymentTypeConfig.payPal"
          :isLimitedExemption="isLimitedExemption"
          @submit="recharge"
        ></Submit>
        <div class="help-box" @click="toCustomer">
          <span>儲值遇到問題</span>
          <img src="~@/assets/images/question-gray.png" alt="" srcset="" />
        </div>
      </div>

      <form :action="paymentObj.payUrl" method="post" id="payment-form">
        <input type="hidden" name="MerchantID" :value="paymentObj.storeId" />
        <input type="hidden" name="RespondType" value="JSON" />
        <input type="hidden" name="CheckValue" :value="rechargeInfo.nonce" />
        <input
          type="hidden"
          name="TimeStamp"
          :value="Math.floor(rechargeInfo.createTime / 1000)"
        />
        <input type="hidden" name="Version" value="1.2" />
        <input
          type="hidden"
          name="MerchantOrderNo"
          :value="rechargeInfo.orderNo"
        />
        <input type="hidden" name="Amt" :value="checkedNumber" />
        <input type="hidden" name="LoginType" value="0" />
        <input type="hidden" name="BrowserProcess" value="1" />
        <input type="hidden" name="Email" :value="email" />
        <input type="hidden" name="ItemDesc" value="儲值" />
        <input type="hidden" name="ReturnURL" :value="paymentObj.hostUrl" />
        <input type="hidden" :name="checkSavingMethod.code" value="1" />
        <input
          type="hidden"
          :name="checkSavingMethod.validity"
          :value="checkSavingMethod.time"
        />
        <input type="hidden" name="TokenTerm" :value="tokenTerm" />
        <input type="hidden" name="TokenTermDemand" value="3" />
      </form>
      <form
        :action="funPointPaymentObj.payUrl"
        method="post"
        id="funpoint-form"
      >
        <input
          type="hidden"
          name="MerchantID"
          :value="funpointResult.MerchantID"
        />
        <input
          type="hidden"
          name="MerchantTradeNo"
          :value="funpointResult.MerchantTradeNo"
        />
        <input
          type="hidden"
          name="MerchantTradeDate"
          :value="funpointResult.MerchantTradeDate"
        />
        <input
          type="hidden"
          name="PaymentType"
          :value="funpointResult.PaymentType"
        />
        <input
          type="hidden"
          name="TotalAmount"
          :value="funpointResult.TotalAmount"
        />
        <input
          type="hidden"
          name="TradeDesc"
          :value="funpointResult.TradeDesc"
        />
        <input type="hidden" name="ItemName" :value="funpointResult.ItemName" />
        <input
          type="hidden"
          name="ReturnURL"
          :value="funpointResult.ReturnURL"
        />
        <input
          type="hidden"
          name="ChoosePayment"
          :value="funpointResult.ChoosePayment"
        />
        <input
          type="hidden"
          name="CheckMacValue"
          :value="funpointRechargeInfo.nonce"
        />
        <input
          type="hidden"
          name="EncryptType"
          :value="funpointResult.EncryptType"
        />
        <input
          type="hidden"
          name="ClientBackURL"
          :value="funpointResult.ClientBackURL"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TappayPage from './tappay-page';
import { loadScript } from '@paypal/paypal-js';
import { bindOrder } from '@/api/order';
import Submit from './submit.vue';

export default {
  components: {
    TappayPage,
    Submit
  },
  props: {
    tokenType: {
      type: String,
      default: 'nicee' //nicee币 diamond钻石
    },
    //從什麼地方進來儲值
    linkSource: {
      type: String,
      default: '' //tw hk
    }
  },

  data() {
    return {
      tokenTerm: '',
      activitySwitch: false,
      rechargeInfo: {},
      paymentObj: {
        payUrl: '',
        storeId: '',
        nonce: '',
        hostUrl: ''
      },
      checkedNumber: null,
      checkedId: null,
      numberArr: [
        { paymentAmount: 100, rechargeAward: 0 },
        { paymentAmount: 300, rechargeAward: 0 },
        { paymentAmount: 500, rechargeAward: 0 },
        { paymentAmount: 1000, rechargeAward: 0 },
        { paymentAmount: 3000, rechargeAward: 0 },
        { paymentAmount: 5000, rechargeAward: 0 },
        { paymentAmount: 10000, rechargeAward: 0 },
        { paymentAmount: 20000, rechargeAward: 0 }
      ],
      funpointResult: {
        EncryptType: 1,
        ItemName: '心約餘額',
        PaymentType: 'aio',
        MerchantTradeDate: '',
        ReturnURL: '',
        MerchantID: '1000031',
        TotalAmount: 12,
        MerchantTradeNo: 'PM1666335865091385',
        TradeDesc: '心約餘額',
        ChoosePayment: 'ALL',
        ClientBackURL: ''
      },
      //FunPoint支付
      funpointRechargeInfo: {},
      funPointPaymentObj: {
        payUrl: '', // FunPoint金流支付url
        hostUrl: '' // 付款完成通知回傳網址
      },
      // 当前已选的支付方式
      checkPayType: 'CREDIT',
      // 支付类型枚举
      payTypeEnum: {
        CREDIT: 'CREDIT',
        CVS: 'CVS',
        ATM: 'ATM',
        WECHAT: 'WECHAT',
        PAYPAL: 'PAYPAL',
        ALIPAY: 'ALIPAY'
      },
      // 每种支付类型所選用的金流支付商
      payShopEnum: {
        CVS: 'lanXin', //lanXin funPoint
        CREDIT: 'tapPay', //lanXin payPal tapPay funPoint
        ATM: 'lanXin', //lanXin funPoint
        WECHAT: 'fomoPay', // fomoPay
        ALIPAY: 'fomoPay', // fomoPay
        PAYPAL: 'payPal' // payPal
      },
      checkSavingMethod: {},
      email: localStorage.getItem('LAST_EMAIL') || '',
      // 支付金流枚举
      paymentTypeConfig: {
        lanXin: 'lanXin',
        funPoint: 'funPoint',
        fomoPay: 'fomoPay',
        payPal: 'payPal',
        tapPay: 'tapPay',
        stripe: 'stripe'
      },
      iapLoading: false,
      payLoading: false,
      isGetPayShopConfig: false, //是否已加载支付方式配置
      iapItemSelected: {},
      controller: new AbortController(),
      controller2: new AbortController(),
      creditNumberArr: null, // 信用卡儲值檔位
      creditActivitySwitch: false,
      creditStoreSize: 300, //根据金额选用储值金额大小
      isMergeCreditCardUser: true //新人和白名单（新人为未超过3000累计储值）全部tappay,其他则判断是否是小于等于creditStoreSize使用tappay支付，大于creditStoreSize使用stripe的用户
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'accountInfo', 'redCircleInfo']),
    deadLineDate() {
      let date = new Date(this.deadLineTime);
      return date.getMonth() + 1 + '月' + date.getDate() + '日';
    },
    hasGift() {
      return this.numberArr.some(item => {
        return item.rechargeAwardSwitch;
      });
    },
    // 储值档位类型
    niceeItemType() {
      const defaultStr = 'WebPay';
      if (this.checkPayType === this.payTypeEnum.ALIPAY) {
        return 'FOMO_ZFB_WEB';
      }
      if (this.hasCommission) {
        let paymentMethod = '';
        switch (this.paymentType) {
          case this.paymentTypeConfig.tapPay:
            paymentMethod = 'TAB_PAY_CARD';
            break;
          case this.paymentTypeConfig.funPoint:
            paymentMethod = 'FUN_POINT';
            break;
          case this.paymentTypeConfig.payPal:
            paymentMethod = 'PayPal_CheckOut';
            break;
          case this.paymentTypeConfig.fomoPay:
            paymentMethod = defaultStr;
            break;
          case this.paymentTypeConfig.lanXin:
            paymentMethod =
              this.checkPayType == this.payTypeEnum.CVS
                ? 'LanXinSupermarket'
                : 'LanXinATM';
            break;
          case this.paymentTypeConfig.stripe:
            paymentMethod = 'StripeCheckOut';
            break;
          default:
            paymentMethod = defaultStr;
            break;
        }
        return paymentMethod;
      } else {
        return defaultStr;
      }
    },
    // 支付配置
    payOptions() {
      return {
        // 信用卡
        CREDIT: {
          lanXin: {
            value: 'LanXinCreditCard',
            payMethodInfo: {
              code: 'CREDIT',
              validity: 'TradeLimit',
              time: 900
            }
          },
          payPal: {
            value: 'PayPal_CheckOut'
          },
          tapPay: {
            value: 'TAB_PAY_CARD'
          },
          funPoint: {
            value: 'FUN_POINT'
          },
          stripe: {
            value: 'StripeCheckOut'
          }
        },
        // 超商代碼繳費
        CVS: {
          lanXin: {
            value: 'LanXinSupermarket',
            payMethodInfo: {
              code: 'CVS',
              validity: 'ExpireDate',
              time: this.validTime
            }
          },
          funPoint: {
            value: 'FUN_POINT'
          }
        },
        // ATM转账
        ATM: {
          lanXin: {
            value: 'LanXinATM',
            payMethodInfo: {
              code: 'VACC',
              validity: 'ExpireDate',
              time: this.validTime
            }
          },
          funPoint: {
            value: 'FUN_POINT'
          }
        },
        // WECHAT
        WECHAT: {
          fomoPay: {
            value: 'FOMO_WX_WEB'
          }
        },
        // WECHAT
        ALIPAY: {
          fomoPay: {
            value: 'FOMO_ZFB_WEB'
          }
        },
        // 直接使用信用卡号
        CARD: {
          tappay: {
            value: 'TAB_PAY_CARD'
          }
        },
        // 直接使用信用卡号
        PAYPAL: {
          payPal: {
            value: 'PayPal_CheckOut'
          }
        }
      };
    },
    // paypal提交按鈕的id
    submitId() {
      return 'submit' + ((Math.random() * 1000) | 0);
    },
    uuid() {
      return this.userInfo && this.userInfo.uuid ? this.userInfo.uuid : null;
    },
    // 支付方式，最终传递给后端的值
    paymentMethod() {
      return this.payOptions[this.checkPayType][
        this.payShopEnum[this.checkPayType]
      ]['value'];
    },
    // 支付金流
    paymentType() {
      return this.payShopEnum[this.checkPayType];
    },
    showEmail() {
      const list = [
        this.paymentTypeConfig.payPal,
        this.paymentTypeConfig.fomoPay,
        this.paymentTypeConfig.stripe
      ];
      return !list.includes(this.paymentType);
    },
    //是否有手续费
    hasCommission() {
      //正式环境无正式用途，只是方便测试用
      if (
        process.env.VUE_APP_ENV === 'test' ||
        process.env.VUE_APP_ENV === 'development'
      ) {
        return this.$route.query.noCommission === 'true' ? false : true;
      } else {
        return true;
      }
    },
    // 白名单测试用户，可以使用最低档位10元进行测试，stripe和paypal为40元
    isWhiteTestList() {
      if (
        process.env.VUE_APP_ENV === 'test' ||
        process.env.VUE_APP_ENV === 'development'
      ) {
        return true;
      }
      return (
        this.uuid &&
        [
          '3698758',
          '250226',
          '4071691',
          '1054918',
          '3826053',
          '4290568',
          '3826053'
        ].includes(this.uuid)
      );
    },
    // 是否限免
    isLimitedExemption() {
      return false;
      // return this.paymentType === 'stripe';
    },
    // 将信用卡合并
    isMergeCreditCard() {
      if (this.onlyUseStripe) {
        return false;
      }
      if (this.linkSource == 'hk' || this.linkSource == 'tw') {
        return false;
      }
      return this.isMergeCreditCardUser;
    },
    //是否储值钻石
    isRechargeDiamond() {
      return this.tokenType === 'diamond';
    },
    //支持的信用卡
    creditCardInfo() {
      if (this.payShopEnum.CREDIT == 'tapPay') {
        return 'Visa/MasterCard/JCB';
      } else {
        return 'Visa/MasterCard/AmEx/銀聯';
      }
    },
    onlyUseStripe() {
      const today = new Date();
      const targetDate = new Date(2024, 9, 3);
      return today < targetDate;
    }
  },
  watch: {
    uuid: {
      handler: function(uuid) {
        if (uuid) {
          this.$http
            .get('/payment/rechargeIsHold', { userUuid: uuid })
            .then(({ data }) => {
              if (data) {
                this.$confirm({
                  message:
                    '您當前賬號的信用異常，暫停下單/儲值功能。如有疑問，請搜索添加"nicee小管家"咨詢',
                  title: '提示',
                  showCancelButton: false,
                  showConfirmButton: true,
                  showClose: false,
                  confirmButtonText: '馬上聯係',
                  closeOnClickModal: false,
                  customClass: 'line-recharge-dialog-center'
                }).then(() => {
                  this.$router.push(`/player-detail/250226?skillId=121218`);
                });
              }
            })
            .catch(() => {});
        }
      },
      immediate: true
    }
  },
  created() {
    Promise.all([this.getRechargeAction(), this.getPayShopConfig()]).then(
      () => {
        if (this.onlyUseStripe) {
          this.payShopEnum.CREDIT = this.paymentTypeConfig.stripe;
        } else {
          if (!this.isMergeCreditCardUser) {
            this.payShopEnum.CREDIT = this.paymentTypeConfig.tapPay;
          }
          if (this.linkSource === 'hk') {
            this.payShopEnum.CREDIT = this.paymentTypeConfig.stripe;
          }
          //tw使用tappay
          if (this.linkSource === 'tw') {
            this.payShopEnum.CREDIT = this.paymentTypeConfig.tapPay;
          }
        }
        this.selectPayType(this.payTypeEnum.CREDIT);
      }
    );
    this.funPointPaymentObj.payUrl = process.env.VUE_APP_FUNPOINT;
    this.funPointPaymentObj.hostUrl =
      location.protocol +
      '//' +
      location.host +
      '/saving' +
      '?' +
      'isSuccess=1';
    this.paymentObj.payUrl = process.env.VUE_APP_PAY_URL;
    this.paymentObj.storeId = process.env.VUE_APP_MERCHANTID;
    this.paymentObj.hostUrl =
      location.protocol +
      '//' +
      location.host +
      '/saving' +
      '?' +
      'isSuccess=1';
    if (this.$route.query.redirect) {
      this.paymentObj.hostUrl = decodeURIComponent(this.$route.query.redirect);
    }
  },

  methods: {
    toCustomer() {
      if (this.userInfo) {
        this.$util.openChatWindow(this.uuid, '250226');
      } else {
        this.$util.Login();
      }
    },
    async getRechargeAction() {
      const { data } = await this.$http.get('/payment/recharge/action2');
      //新人和白名单（新人为未超过3000累计储值）全部tappay
      if (data == 1) {
        this.isMergeCreditCardUser = false;
      } else {
        this.isMergeCreditCardUser = true;
      }
    },
    selectCreditCardPayment() {
      if (this.iapItemSelected) {
        if (
          this.iapItemSelected.receivedAmount != undefined &&
          this.iapItemSelected.receivedAmount <= this.creditStoreSize
        ) {
          this.payShopEnum.CREDIT = 'tapPay';
          this.selectPayType(this.payTypeEnum.CREDIT);
        } else {
          this.payShopEnum.CREDIT = 'stripe';
          this.selectPayType(this.payTypeEnum.CREDIT);
        }
      } else {
        if (this.payShopEnum.CREDIT == 'tapPay') {
          this.selectPayType(this.payTypeEnum.CREDIT);
        } else {
          this.selectPayType(this.payTypeEnum.CREDIT);
        }
      }
    },
    getCreditIapList() {
      if (this.creditNumberArr) {
        this.numberArr = this.creditNumberArr;
        const iapItem = this.numberArr.find(item => {
          return item.receivedAmount === this.iapItemSelected.receivedAmount;
        });
        if (iapItem) {
          this.setCreditNumber(iapItem);
        } else {
          this.setCreditNumber({ paymentAmount: null, checkedId: null });
        }
        this.activitySwitch = this.creditActivitySwitch;
        return;
      }
      if (this.iapLoading) {
        this.controller.abort();
        this.controller = new AbortController();
        this.controller2.abort();
        this.controller2 = new AbortController();
      }
      this.iapLoading = true;
      Promise.all([
        this.$http.get(
          '/iap/item/list/recharge',
          {
            paymentMethod: 'TAB_PAY_CARD'
          },
          {
            signal: this.controller.signal
          }
        ),
        this.$http.get(
          '/iap/item/list/recharge',
          {
            paymentMethod: 'StripeCheckOut'
          },
          {
            signal: this.controller2.signal
          }
        )
      ])
        .then(list => {
          const data = list[0].data;
          const data1 = list[1].data;
          if (
            data &&
            Array.isArray(data.iapItemsVo) &&
            data1 &&
            Array.isArray(data1.iapItemsVo)
          ) {
            this.deadLineTime = data.datetime;
            let numberArr = [];
            let numberArr1 = [];
            numberArr = data.iapItemsVo.filter(item => {
              return !this.isWhiteTestList
                ? item.receivedAmount != 40 &&
                    item.receivedAmount <= this.creditStoreSize
                : item.receivedAmount <= this.creditStoreSize;
            });
            numberArr1 = data1.iapItemsVo.filter(item => {
              return item.receivedAmount > this.creditStoreSize;
            });
            this.numberArr = [...numberArr, ...numberArr1];
            this.activitySwitch = data.activitySwitch || data.activitySwitch;
            this.creditActivitySwitch = this.activitySwitch;
            this.creditNumberArr = [...numberArr, ...numberArr1];
            const iapItem = this.numberArr.find(item => {
              return (
                item.receivedAmount === this.iapItemSelected.receivedAmount
              );
            });
            if (iapItem) {
              this.setCreditNumber(iapItem);
            } else {
              this.setCreditNumber({ paymentAmount: null, checkedId: null });
            }
          }
        })
        .finally(() => {
          this.iapLoading = false;
        });
    },
    getCommonIapList() {
      if (this.iapLoading) {
        this.controller.abort();
        this.controller = new AbortController();
      }
      this.iapLoading = true;
      this.$http
        .get(
          '/iap/item/list/recharge',
          {
            paymentMethod: this.niceeItemType
          },
          {
            signal: this.controller.signal
          }
        )
        .then(({ data }) => {
          if (data && Array.isArray(data.iapItemsVo)) {
            this.deadLineTime = data.datetime;
            this.numberArr = data.iapItemsVo;
            if (!this.isWhiteTestList) {
              if (this.checkPayType === this.payTypeEnum.ALIPAY) {
                this.numberArr = this.numberArr.filter(item => {
                  return item.receivedAmount != 4;
                });
              } else {
                this.numberArr = this.numberArr.filter(item => {
                  if (
                    this.paymentType === this.paymentTypeConfig.payPal ||
                    this.paymentType === this.paymentTypeConfig.stripe
                  ) {
                    return item.receivedAmount != 40;
                  } else {
                    return item.receivedAmount != 10;
                  }
                });
              }
            }
            this.activitySwitch = data.activitySwitch;
            const iapItem = this.numberArr.find(item => {
              return (
                item.receivedAmount === this.iapItemSelected.receivedAmount
              );
            });
            if (iapItem) {
              this.changeNumber(iapItem);
            } else {
              this.changeNumber({ paymentAmount: null, checkedId: null });
            }
          }
        })
        .finally(() => {
          this.iapLoading = false;
        });
    },
    getIapList() {
      if (this.isMergeCreditCard && this.checkPayType === 'CREDIT') {
        this.getCreditIapList();
      } else {
        this.getCommonIapList();
      }
    },
    changeNumber(iapItem) {
      const { paymentAmount, iapItemId } = iapItem;
      this.checkedNumber = paymentAmount;
      this.checkedId = iapItemId;
      this.iapItemSelected = iapItem;
      if (this.isMergeCreditCard && this.checkPayType === 'CREDIT') {
        this.selectCreditCardPayment();
      }
    },
    setCreditNumber(iapItem) {
      const { paymentAmount, iapItemId } = iapItem;
      this.checkedNumber = paymentAmount;
      this.checkedId = iapItemId;
      this.iapItemSelected = iapItem;
    },

    recharge() {
      if (!this.userInfo) {
        this.$util.Login();
      } else {
        if (!this.paymentMethod) return this.$message.error('請選擇儲值方式');
        if (!this.checkedNumber) return this.$message.error('請選擇儲值金額');
        if (this.paymentType === this.paymentTypeConfig.lanXin) {
          this.lanxinRecharge();
        } else if (this.paymentType === this.paymentTypeConfig.funPoint) {
          this.funPointRecharge();
        } else if (this.paymentType === this.paymentTypeConfig.tapPay) {
          this.tappaySubmit();
        } else if (this.paymentType === this.paymentTypeConfig.fomoPay) {
          if (this.checkPayType === this.payTypeEnum.ALIPAY) {
            this.alipayRecharge();
          }
        } else if (this.paymentType === this.paymentTypeConfig.stripe) {
          this.stripeRecharge();
        }
      }
    },
    // 验证邮箱必填
    validEmail() {
      if (!this.email) {
        this.$message.error('請輸入您的電子郵箱');
        return false;
      } else if (!/^(\w+\.)*\w+@\w+(.\w+)+$/.test(this.email)) {
        this.$message.error('電子郵箱格式不正確');
        return false;
      } else {
        return true;
      }
    },
    lanxinRecharge() {
      if (!this.validEmail()) {
        return;
      }
      this.$http
        .post('/payment/recharge', {
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: this.paymentMethod,
          email: this.email
        })
        .then(async data => {
          this.rechargeInfo = data.data;
          localStorage.setItem('LAST_EMAIL', this.email);
          // this.paymentObj.nonce = data.nonce
          if (this.checkSavingMethod.code !== 'CREDIT') {
            let cur = new Date();
            let validDate = new Date(cur.getTime() + 48 * 60 * 60 * 1000);
            let monthper = validDate.getMonth() > 8 ? '' : '0';
            let month = validDate.getMonth() + 1;
            let monthString = monthper + month.toString();
            let datePer = validDate.getDate() > 9 ? '' : '0';
            let dateString = datePer + validDate.getDate().toString();
            let validTime =
              validDate.getFullYear().toString() + monthString + dateString;
            this.checkSavingMethod.time = validTime;
          }
          await this.reportPayType(data.data.orderNo);
          this.$nextTick(() => {
            document.querySelector('#payment-form').submit();
            const { params } = this.$route;
            if (params.isCommentSendGift) {
              setTimeout(() => {
                window.sessionStorage.setItem(
                  'GIFT_AFTER_COMMENT',
                  JSON.stringify(params)
                );
                this.$router.go(-1);
              }, 2000);
            }
          });
        })
        .catch(err => {
          // this.$message.error(err.msg)
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
        });
    },
    // 获取funpoint的收款方式
    getFunpointPayment() {
      if (this.checkPayType === 'CREDIT') {
        return 'Credit';
      }
      if (this.checkPayType === 'ATM') {
        return 'ATM';
      }
      if (this.checkPayType === 'CVS') {
        return 'CVS';
      }
      return 'ALL';
    },

    //FunPoint金流
    funPointRecharge() {
      if (!this.validEmail()) {
        return;
      }
      const funpointChoosePayment = this.getFunpointPayment();
      this.$http
        .post('/payment/recharge', {
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: this.paymentMethod,
          successUrl: this.funPointPaymentObj.hostUrl,
          email: this.email,
          funpointChoosePayment
        })
        .then(async ({ data }) => {
          this.funpointRechargeInfo = data;
          this.funpointResult = data.result;
          localStorage.setItem('LAST_EMAIL', this.email);
          await this.reportPayType(data.orderNo);
          this.$nextTick(() => {
            document.querySelector('#funpoint-form').submit();
          });
        })
        .catch(err => {
          // this.$message.error(err.msg)
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
        });
    },
    // tappay提交表單
    tappaySubmit() {
      if (!this.validEmail()) {
        return;
      }
      this.$refs.tappay.handleSubmit();
    },
    // tappal支付
    tappayRecharge(submitObj) {
      const { remember, prime, cardId } = submitObj;
      if (!prime) {
        this.$message.error('信用卡信息有誤');
        return;
      }
      const isDevelopment = process.env.VUE_APP_ENV === 'development'; //是否是開發環境
      this.payLoading = true;
      const successUrl = `${
        isDevelopment ? 'https://test.nicee.tw' : location.origin
      }${location.pathname}?&isTappay=true&price=${this.checkedNumber}&uuid=${
        this.uuid
      }&`;
      const params = {
        amount: this.checkedNumber,
        iapItemId: this.checkedId,
        paymentMethod: this.paymentMethod,
        tabPalPrime: prime,
        successUrl: successUrl,
        email: this.email
      };
      if (!cardId) {
        params['remember'] = remember;
      }
      this.$http
        .post('/payment/recharge', params)
        .then(async ({ data }) => {
          if (data.result.url) {
            if (this.linkSource == 'tw') {
              await this.$report(this.checkedNumber);
              // await this.$report({
              //   message: JSON.stringify({
              //     amount: this.checkedNumber,
              //     source: this.linkSource,
              //     paymentMethod: this.paymentMethod,
              //     orderNo: data.orderNo
              //   })
              // });
            }
            await this.reportPayType(data.orderNo);
            localStorage.setItem('LAST_EMAIL', this.email);
            window.open(data.result.url, '_self');
            this.payLoading = false;
          } else {
            this.$message.error('创建订单失败');
            this.payLoading = false;
          }
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
          this.payLoading = false;
        });
    },

    // 生成paypal支付按鈕
    renderButton() {
      const paypayScriptConfig = {
        'client-id': process.env.VUE_APP_CLIENT_ID,
        'disable-funding': 'credit,card',
        currency: 'TWD',
        intent: 'authorize'
      };
      // 按鈕相關設置
      const buttonConfig = {
        style: {
          height: 46
        },
        // 創建paypal訂單
        createOrder: this.createPaypalOrder,
        // 支付成功
        onApprove: this.paypalPaySuccess,
        onError: err => {
          console.warn(err);
          this.$message({
            message: 'paypal支付失败',
            type: 'error',
            customClass: 'paypal-status'
          });
          this.payLoading = false;
        },
        onCancel: err => {
          console.warn(err);
          this.$message({
            message: '已取消paypal支付',
            type: 'error',
            customClass: 'paypal-status'
          });
          this.payLoading = false;
        },
        onClick: async (data, actions) => {
          if (!this.userInfo) {
            this.$message.error('未登录');
            return actions.reject();
          }
          if (!this.checkedNumber) {
            this.$message.error('請选择储值金额');
            return actions.reject();
          }
          try {
            this.payLoading = true;
            const result = await this.$http.post('/payment/recharge', {
              uuid: this.uuid,
              amount: this.checkedNumber,
              iapItemId: this.checkedId,
              paymentMethod: this.paymentMethod,
              payPalId: 'paypalId'
            });
            if (result && result.data) {
              this.reportPayType(result.data.orderNo);
              this.rechargeInfo = result.data;
              return actions.resolve();
            } else {
              throw new Error('创建订单失败');
            }
          } catch (err) {
            this.$message({
              message: '创建订单失败',
              type: 'error',
              customClass: 'paypal-status'
            });
            return actions.reject();
          }
        }
      };
      // 用來渲染按鈕的元素id
      const id = '#' + this.submitId;
      loadScript(paypayScriptConfig)
        .then(paypal => {
          this.paypalButton = paypal.Buttons(buttonConfig);
          this.paypalButton.render(id).catch(error => {
            console.error('failed to render the PayPal Buttons', error);
          });
        })
        .catch(error => {
          console.error('failed to load the PayPal JS SDK script', error);
        });
    },

    isSuccess() {
      const url = this.$route.query;
      if (url.isSuccess) {
        const query = this.$route.query;
        const newQuery = {};

        Object.keys(query).forEach(key => {
          if (key !== 'isSuccess') {
            newQuery[key] = query[key];
          }
        });

        this.$router.replace({
          name: 'Saving',
          query: newQuery
        });
      }
    },

    // 創建paypal訂單
    async createPaypalOrder(data, actions) {
      return actions.order
        .create({
          purchase_units: [
            {
              // 商品
              amount: {
                currency_code: 'TWD', //新台幣
                value: this.checkedNumber //金額
              },
              invoice_id: this.rechargeInfo.orderNo,
              payer: {}
            }
          ]
        })
        .then(async orderData => {
          return orderData;
        })
        .catch(() => {
          this.$message({
            message: 'paypal创建订单失败',
            type: 'error',
            customClass: 'paypal-status'
          });
        });
    },
    // 支付成功
    paypalPaySuccess(data, actions) {
      actions.order
        .authorize()
        .then(authorization => {
          // Get the authorization id
          var authorizationID =
            authorization.purchase_units[0].payments.authorizations[0].id;
          this.payLoading = false;
          this.$message({
            message: '支付成功',
            type: 'success',
            customClass: 'paypal-status'
          });
          // 充值nicee币
          bindOrder({
            orderId: data.orderID,
            authId: authorizationID,
            orderNo: this.rechargeInfo.orderNo
          }).finally(() => {
            window.location.reload();
          });
        })
        .catch(() => {
          this.$message({
            message: 'paypal获取授权失败',
            type: 'error',
            customClass: 'paypal-status'
          });
          this.payLoading = false;
        });
    },
    //上报支付渠道
    async reportPayType(orderNo) {
      //deskType 1/新版收银台 2/旧版
      // type. 1/官网包 2/line 3/pcWEB页面
      try {
        await this.$http.post('/payment/recharge/event/save', {
          deskType: 1,
          type: 3,
          uuid: this.uuid,
          orderNo
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 選擇支付類型
    selectPayType(payType) {
      this.checkPayType = payType;
      this.checkSavingMethod =
        this.payOptions[payType][this.payShopEnum[payType]]['payMethodInfo'] ||
        {};
      this.getIapList();
      // this.checkedNumber = null;
      // this.checkedId = null;
    },
    //fomopay金流
    fomopayRecharge() {
      this.payLoading = true;
      const successUrl = `${location.origin}${location.pathname}?isFomoPay=true&price=${this.checkedNumber}&uuid=${this.uuid}&`;
      const cancelUrl = `${location.origin}${location.pathname}?isFomoPay=false&price=${this.checkedNumber}&uuid=${this.uuid}&`;
      this.$http
        .post('/payment/recharge', {
          uuid: this.uuid,
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: this.paymentMethod,
          successUrl: successUrl,
          cancelUrl: cancelUrl
        })
        .then(async ({ data }) => {
          if (data.result.url) {
            await this.reportPayType(data.orderNo);
            window.open(data.result.url, '_self');
            this.payLoading = false;
          } else {
            this.$message.error('创建订单失败');
            this.payLoading = false;
          }
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
          this.payLoading = false;
        });
    },
    //stripe金流
    stripeRecharge() {
      if (!this.checkedNumber) return this.$message.error('請選擇儲值金額');
      this.payLoading = true;
      const successUrl = `${location.origin}${location.pathname}?&isStripe=true&price=${this.checkedNumber}&`;
      const cancelUrl = `${location.origin}${location.pathname}?&isStripe=false&price=${this.checkedNumber}&`;
      this.$http
        .post('/payment/recharge', {
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: this.paymentMethod,
          successUrl: successUrl,
          cancelUrl: cancelUrl
        })
        .then(async ({ data }) => {
          if (data.nonce) {
            await this.reportPayType(data.orderNo);
            window.open(data.nonce, '_self');
            this.payLoading = false;
          } else {
            this.$message.error('创建订单失败');
            this.payLoading = false;
          }
        })
        .catch(err => {
          // this.$message.error(err.msg)
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
        });
    },
    // 获取信用卡配置
    async getPayShopConfig() {
      try {
        const { data } = await this.$http.get('/payment/recharge/action');
        //       "data": {
        // 	"appleMethod": "",//apple方式 Apple
        // 	"atmMethod": "",//atm方式 LanXin FUN_POINT
        // 	"cardMethod": "",//信用卡方式  LanXin FUN_POINT TAB_PAY PayPal
        // 	"supermarketMethod": "",//商超代码方式 LanXin FUN_POINT
        // 	"wechatMethod": ""//wechat方式 FOMO
        // },
        // 每种金流的支付商
        // payShopEnum: {
        //   CVS: 'lanXin', //lanXin funPoint
        //   CREDIT: 'payPal', //lanXin payPal tapPay funPoint
        //   ATM: 'lanXin', //lanXin funPoint
        //   WECHAT: 'fomoPay', // fomoPay
        // },
        if (data) {
          switch (data.supermarketMethod) {
            case 'LanXin':
              this.payShopEnum.CVS = this.paymentTypeConfig.lanXin;
              break;
            case 'FUN_POINT':
              this.payShopEnum.CVS = this.paymentTypeConfig.funPoint;
              break;
            default:
              break;
          }
          switch (data.cardMethod) {
            case 'LanXin':
              this.payShopEnum.CREDIT = this.paymentTypeConfig.lanXin;
              break;
            case 'FUN_POINT':
              this.payShopEnum.CREDIT = this.paymentTypeConfig.funPoint;
              break;
            case 'TAB_PAY':
              this.payShopEnum.CREDIT = this.paymentTypeConfig.tapPay;
              break;
            case 'PayPal':
              this.payShopEnum.CREDIT = this.paymentTypeConfig.payPal;
              break;
            case 'Stripe':
              this.payShopEnum.CREDIT = this.paymentTypeConfig.stripe;
              break;
            default:
              break;
          }
          switch (data.atmMethod) {
            case 'LanXin':
              this.payShopEnum.ATM = this.paymentTypeConfig.lanXin;
              break;
            case 'FUN_POINT':
              this.payShopEnum.ATM = this.paymentTypeConfig.funPoint;
              break;
            default:
              break;
          }
          switch (data.wechatMethod) {
            case 'FOMO':
              this.payShopEnum.WECHAT = this.paymentTypeConfig.fomoPay;
              break;
            default:
              break;
          }
          this.isGetPayShopConfig = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    //支付寶儲值
    alipayRecharge() {
      this.payLoading = true;
      const successUrl = `${location.origin}${location.pathname}?isFomoAlipay=true&price=${this.checkedNumber}&uuid=${this.uuid}&`;
      const cancelUrl = `${location.origin}${location.pathname}?isFomoAlipay=false&price=${this.checkedNumber}&uuid=${this.uuid}&`;
      this.$http
        .post('/payment/recharge', {
          uuid: this.uuid,
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: this.paymentMethod,
          successUrl: successUrl,
          cancelUrl: cancelUrl
        })
        .then(async ({ data }) => {
          if (data.result.url) {
            await this.reportPayType(data.orderNo);
            window.open(data.result.url, '_self');
            this.payLoading = false;
          } else {
            this.$message.error('创建订单失败');
            this.payLoading = false;
          }
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
          this.payLoading = false;
        });
    }
  },
  mounted() {
    this.isSuccess();
    this.renderButton();
  }
};
</script>

<style lang="scss" scoped>
.tip-wrap {
  font-size: 14px;
  line-height: 22px;
  color: $color-gray-3;
  margin-bottom: 20px;
}
.email-input {
  width: 432px;
  max-width: 100%;
  background: #f9f9f9;
  border: 1px solid $color-split;
  padding: 12px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: $color-gray-1;
  &::placeholder {
    color: $color-gray-4;
  }
}
.save-wrap {
  padding-top: 36px;
}
.save-price {
  margin-top: 20px;
}
.curBalance img {
  height: 18px;
  margin: 0 4px 0 7px;
  vertical-align: middle;
}
.gold-img {
  height: 16px;
  vertical-align: middle;
}
.gold-counts {
  display: inline-block;
  vertical-align: middle;
  font-style: normal;
}
.deadline {
  margin-top: 10px;
  font-size: 12px !important;
  line-height: 17px !important;
  color: #636d86 !important;
}
.dead-time {
  color: $color-orange;
}
.balance {
  @include flex;
  height: 32px;
  padding: 4px;
  margin-left: 20px;
  border-radius: 32px;
  background-color: #f1f4f6;
  img {
    width: 24px;
    height: 24px;
  }
  span {
    margin: 0 12px;
    color: $color-gray-1;
    font-size: 14px;
    font-weight: 600;
  }
}
.credit-card {
  margin-bottom: 20px;
}
.gift-num {
  position: absolute;
  display: block;
  top: -4px;
  left: -2px;
  padding: 4px 16px;
  background: #fed838;
  border-radius: 4px 0 4px 0;
  font-size: 15px;
  line-height: 1;
  color: #cb6100;
}
.saving-wrap {
  margin: 0 auto 60px !important;
  @include hideScrollBar(0);
  @include whiteBox;
  box-sizing: border-box;
  overflow-y: auto;
  background: white;
  .saving-header {
    display: flex;
    align-items: center;
    height: 76px;
    width: 100%;
    line-height: 76px;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    color: #222c43;
    box-sizing: border-box;
    padding: 0 40px;
    border-bottom: 1px solid #f4f4f4;
    font-weight: bold;
    .mobileSaving {
      display: none;
    }
  }
  // .confrim-save-btn-m {
  //   display: none;
  // }
  .saving-content {
    box-sizing: border-box;
    padding: 24px 40px;
    &.has-commission {
      padding-bottom: 0;
      // .email-input {
      //   margin-bottom: 30px;
      // }
    }

    .line-title {
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      color: #222c43;
      margin-bottom: 12px;
      &.line-title-price {
        margin-top: 40px;
      }
      &.recharge-type-title {
        margin-bottom: 12px;
      }
    }
    .tip-info {
      margin-left: 12px;
      font-weight: 400;
      font-size: 15px;
      color: red;
      font-weight: bold;
    }
    .curBalance {
      font-size: 18px;
      color: $color-orange;
      margin-bottom: 50px;
    }
    .saving-type {
      height: 62px;
      display: flex;
      margin-bottom: 0;
      width: 100%;
      .saving-btn {
        width: 172px;
        height: 62px;
        line-height: 62px;
        text-align: center;
        border: none;
        margin-right: 12px;
        cursor: pointer;
        border-radius: 4px;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        .activity-info {
          position: absolute;
          font-size: 12px;
          padding: 0 10px;
          line-height: 20px;
          display: inline-block;
          color: #ffffff;
          border-radius: 8px;
          left: 50%;
          top: -23px;
          transform: translateX(-50%);
          background-color: #ff5e84;
          min-width: 99px;
          font-weight: 400;
        }
      }
    }
    .saving-number {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 20px;
      box-sizing: border-box;
      .number-btn {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(50% - 10px);
        height: 90px;
        // line-height: 92px;
        border: none;
        margin-bottom: 20px;
        cursor: pointer;
        border-radius: 4px;
        .number-item {
          display: flex;
          justify-content: space-between;
          padding: 0 16px;
          .recharge-num {
            display: flex;
            align-items: center;
            font-style: normal;
            font-weight: 600;
            line-height: 22px;
            font-size: 24px;
            img {
              height: 22px;
              width: 22px;
              margin-right: 4px;
            }
            .send-gold {
              font-size: 14px;
              padding: 0 8px;
              line-height: 20px;
              display: inline-block;
              color: #ffffff;
              border-radius: 7px;
              background-color: #ff5e84;
              margin-left: 14px;
              font-weight: 400;
            }
          }
          .pay-num {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #636d86;
          }
        }
        .badge {
          display: flex;
          position: absolute;
          left: 0;
          top: -10%;
          // width: 44px;
          // height: 20px;
          border-radius: 4px 4px 4px 0;
          // background: rgba(254, 113, 3, 1);
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 12px;
          padding: 2px 4px;
          &.red {
            background: rgb(247, 37, 87);
          }
          &.blue {
            background: rgb(70, 139, 221);
          }
        }
      }
    }
    .paypal-submit-button {
      width: 142px;
    }
    .confrim-save-btn {
      width: 142px;
      height: 46px;
      line-height: 46px;
      font-weight: bold;
      color: #222c43;
      background: $color-yellow;
      border-radius: 30px;
      text-align: center;
      cursor: pointer;
    }
    .number-item {
      @include flex();
      height: 100%;
      width: 100%;
      border-radius: 4px;
      color: #222c43;
      font-size: 14px;
      font-weight: bold;
      border: 1px solid #e8eaee;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: top -1px right -1px;
      background-size: 20px;
      .credit-type {
        color: #a2a2a2;
        font-size: 12px;
        font-weight: 400;
      }
      .we-chat {
        width: 114px;
      }

      &.checked {
        background-color: white;
        background-image: url('./images/icon-check.png');
        border: 2px solid $color-orange;
        color: $color-orange;
        .credit-type {
          color: #fe7f38;
          font-size: 12px;
        }
      }

      &.disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }
    }
  }
  .commission-submit-box {
    position: relative;
    .paypal-box {
      position: absolute;
      width: 148px;
      height: 80px;
      right: 464px;
      top: 14px;
      z-index: 10;
      > div {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
      }
      &.no-price {
        left: 40px;
        right: auto;
      }
    }
    /deep/ .submit {
      position: relative;
    }
  }
}
.first-charge-timer {
  width: 100%;
  height: 70px;
  margin-bottom: 18px;
  border-radius: 4px;
  background: linear-gradient(90.1deg, #fe7f38 0.09%, #fe9738 99.92%);
  font-size: 14px;
  color: #fff;
  @include flex(space-between, flex-start, column);
  font-weight: 500;
  padding: 10px 14px;
  .timer {
    @include flex;
  }
  b {
    width: 24px;
    height: 24px;
    background: #ffe1cf;
    color: #ff5b37;
    border-radius: 3px;
    @include flex;
    margin-right: 4px;
  }
  sub {
    margin-right: 8px;
  }
}
.recharge-type {
  justify-content: flex-start !important;
  .number-btn {
    width: 196px !important;
    height: 62px !important;
  }
  .number-item {
    display: flex;
    justify-content: center !important;
    align-items: center !important;
    margin-right: 20px;
  }
  img {
    max-width: 100px;
  }
}
.bank-tip {
  color: #636d86;
  font-weight: 400 !important;
  line-height: 1.4 !important;
  margin: 40px 0;
  font-size: 14px !important;
}
.creditcard-Info {
  line-height: 1.4;
  .credit-type {
    display: inline-block;
    width: 172px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 2px;
  }
}
.commission-submit-box {
  position: relative;
  .help-box {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: absolute;
    right: 40px;
    top: 48px;
    color: #8c94aa;
    font-size: 12px;
  }
  img {
    width: 14px;
    height: 14px;
    margin-right: 2px;
  }
}
</style>
